import { AppName } from "./utils/constants";
import tenantData from "./tenant-config.json";

/**
 * Everything that varies per tenant build (VITE_APP_NAME), other than the MUI
 * theme itself (see themeMap in theme.ts). This is the single source of truth
 * for tenant branding: display name, in-app logos, and the build-time
 * metadata baked into index.html / manifest.json / favicon.ico by
 * scripts/generate-tenant-metadata.js, which reads the same JSON file.
 */
export interface TenantConfig {
  /** User-facing name shown in the UI (logo alt text, etc). */
  displayName: string;
  /** Login screen logo. */
  logoLogin: string;
  /** Small logo shown in the collapsed drawer / mobile header. */
  logoDrawerSmall: string;
  /** Full logo shown in the expanded desktop drawer header. */
  logoDrawerMain: string;
  /** index.html <title> content, baked in at build time. */
  projectName: string;
  /** index.html <meta name="description"> content, baked in at build time. */
  description: string;
  /** manifest.json short_name, baked in at build time. */
  shortName: string;
  /** manifest.json name, baked in at build time. */
  manifestName: string;
  /** Browser chrome / manifest theme color, baked in at build time. */
  themeColor: string;
  /** manifest.json background_color, baked in at build time. */
  backgroundColor: string;
  /** Filename (in public/) copied to public/favicon.ico at build time. */
  favicon: string;
}

export const TENANT_CONFIG: Record<AppName, TenantConfig> =
  tenantData as Record<AppName, TenantConfig>;

/** Returns the tenant config for the given app name, falling back to FaunaProtect. */
export const getTenantConfig = (appName: AppName): TenantConfig =>
  TENANT_CONFIG[appName] ?? TENANT_CONFIG[AppName.FaunaProtect];
